export default __webpack_public_path__ + "static/media/adobe-photoshop.13f606be.svg";